import STORE from 'store';

const deleteTask = (task: Tasks.Task, accountId: string) => {
  return STORE.getTasksRef({ accountId }).doc(task.id).delete();
};

export default deleteTask;
